/**
 * SpatialCard — "Where your impact lands".
 *
 * The alt-view mounts the SAME real spatial layer the Classic dashboard uses:
 * `GeneratorAttributionCard` (Leaflet map + /projects/{id}/airsheds polygons +
 * per-plant markers + Local/Regional/Global tabs). Spatial has no sensitivity
 * range, so it always renders on Central. The card brings its own dark chrome;
 * we only wrap it in a container that fits the alt-view width and never restyle
 * its internals.
 */

import { GeneratorAttributionCard } from "../../spatial/components/GeneratorAttributionCard";
import type { ModelResults } from "../../model/domain/types";

type Attribution = NonNullable<
  ModelResults["summary_json"]
>["generator_attribution"];
type Congestion = NonNullable<
  ModelResults["summary_json"]
>["congestion_metadata"];

export function SpatialCard({
  attribution,
  congestion,
  projectId,
  projectName,
  projectLatitude,
  projectLongitude,
}: {
  attribution?: Attribution;
  congestion?: Congestion;
  projectId?: string;
  projectName?: string;
  projectLatitude?: number;
  projectLongitude?: number;
}) {
  if (!attribution || !attribution.generators?.length) {
    return (
      <div className="card">
        <div className="ch">
          <h2>Where your impact lands</h2>
          <span className="mut">spatial · Central</span>
        </div>
        <div className="cb">
          <div className="empty">
            No generator-level attribution for this run.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="rd-spatial">
      <GeneratorAttributionCard
        attribution={attribution}
        congestion={congestion}
        projectId={projectId}
        projectName={projectName}
        projectLatitude={projectLatitude}
        projectLongitude={projectLongitude}
      />
    </div>
  );
}
